// @ts-nocheck
/* eslint-disable */
export const fullscreenLineIcon = {
  data: `<svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6.6665 2.5V4.16667H3.33317V7.5H1.6665V2.5H6.6665ZM1.6665 17.5V12.5H3.33317V15.8333H6.6665V17.5H1.6665ZM18.3332 17.5H13.3332V15.8333H16.6665V12.5H18.3332V17.5ZM18.3332 7.5H16.6665V4.16667H13.3332V2.5H18.3332V7.5Z" fill="currentColor"/></svg>`,
  name: 'fullscreen-line' as const,
};
